import { Playground } from '@playground';
import { Form } from 'react-final-form';
import { FFInputNumber } from "../../../../../packages/forms/src/elements/number/number";
import { validate } from "../../../../../packages/forms/src/validation";
import { renderFields } from "../../../../../packages/forms/src/renderFields";
import styles from "../../../../../packages/forms/src/elements/number/input.module.scss";
import * as React from 'react';
export default {
  Playground,
  Form,
  FFInputNumber,
  validate,
  renderFields,
  styles,
  React
};